import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStarTask } from 'components/tasks/utils/useStarTask';
import { twMerge } from 'tailwind-merge';
import { Task } from 'types/domain';

interface StarTaskActionProps extends ComponentPropsWithoutRef<'button'> {
    task: Task;
}
const StarTaskAction = ({ task }: StarTaskActionProps) => {
    const { is_starred } = task;
    const { mutate } = useStarTask(task);

    return (
        <Button
            variant="transparent"
            size="xs"
            className="group/button z-layerFour relative p-0"
            onClick={() => mutate({ star: !is_starred })}
        >
            <FontAwesomeIcon
                icon={is_starred ? faStarSolid : faStar}
                className={twMerge(
                    'h-5 w-5 text-gray-300',
                    is_starred ? 'text-brand-butter-primary' : 'group-hover/button:hidden',
                )}
            />
            <FontAwesomeIcon
                icon={faStar}
                className={twMerge(
                    'text-brand-butter-primary hidden h-5 w-5',
                    !is_starred && 'group-hover/button:block',
                )}
            />
        </Button>
    );
};

export { StarTaskAction };
